module.exports = __webpack_public_path__ + "static/img/logo14.e773682.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo14.png
// module id = XuFI
// module chunks = 1